import { render, staticRenderFns } from "./DraggableFixed.vue?vue&type=template&id=14ff3c94&"
import script from "./DraggableFixed.vue?vue&type=script&lang=js&"
export * from "./DraggableFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports